export default __webpack_public_path__ + "static/benefitImg-7bfba8a4bba8be8c83390e190b4e6a93.png";